import { render } from "./AnswersBlock.vue?vue&type=template&id=1e9ee82c&scoped=true"
import script from "./AnswersBlock.vue?vue&type=script&lang=js"
export * from "./AnswersBlock.vue?vue&type=script&lang=js"

import "./AnswersBlock.vue?vue&type=style&index=0&id=1e9ee82c&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9ee82c"]])

export default __exports__